import { Helmet } from "react-helmet";
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
  usePagination,
  Radio,
  MenuItem,
  FormControl,
  Select,
  OutlinedInput,
  Divider,
  TextareaAutosize,
  TextField,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
// import Request from "../../components/home/Request";
// import { getMyRequestSuccess } from "../../actions";
import { useSelector, useDispatch } from "react-redux";
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom'
import React, { useEffect, useMemo } from "react";
import { styled } from "@mui/material/styles";
import cssVariables from "../../../theme/cssVariables";
import { ReactComponent as SuccessIcon } from "../../../icons/success-icon.svg";
import FeedbackRating from "../../../constants/Feedback";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

// import axios from "axios";
function CustomPagination(props) {
  const useStyles = makeStyles({
    paginationRoot: {
      color: `${cssVariables.color.primary}`,
      backgroundColor: "white!important",
      minWidth: "30px!important",
      padding: "5px!important",
    },
    paginationSelected: {
      color: "white!important",
      border: "1px solid rgba(93, 161, 150, 0.5)!important",
      backgroundColor: `${cssVariables.color.primary}!important`,
      minWidth: "30px!important",
      padding: "5px!important",
    },

  });
  const classes = useStyles();
  const List = styled("ul")({
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "flex",
  });
  const { items } = usePagination({
    count: props.count,
    showFirstButton: true,
    showLastButton: true,
  });
  return (
    <nav>
      <List>
        {items.length > 0 ? (
          items.map(({ page, type, selected, ...item }, index) => {
            let children = null;
            selected = type === "page" && page === props.selected ? props.selected : selected
            if (type === "start-ellipsis" || type === "end-ellipsis") {
              children = "…";
            } else if (type === "page") {
              children = (
                <Button
                  {...item}
                  size="small"
                  type="button"
                  style={{
                    fontWeight: selected ? "bold" : undefined,
                  }}
                  variant="outlined"
                  classes={{
                    root: selected
                      ? classes.paginationSelected
                      : classes.paginationRoot,
                  }}
                  sx={{ margin: "0 5px" }}
                >
                  {page}
                </Button>
              );
            } else if (type === "first" || type === "last") {
              children = (
                <Button
                  {...item}
                  disabled={type === "first" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                  size="small"
                  type="button"
                  style={{
                    fontWeight: selected ? "bold" : undefined,
                  }}
                  variant="outlined"
                  classes={{
                    root: selected
                      ? classes.paginationSelected
                      : classes.paginationRoot,
                  }}
                  sx={{ margin: "0 5px" }}
                >
                  {type === "first" ? <>&lt;&lt;</> : <>&gt;&gt;</>}
                </Button>
              );
            } else {
              children = (
                <Button
                  {...item}
                  disabled={type === "previous" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                  size="small"
                  type="button"
                  variant="outlined"
                  classes={{
                    root: classes.paginationRoot,
                  }}
                >
                  {type === "previous"
                    ? "ก่อนหน้า"
                    : type === "next"
                      ? "ถัดไป"
                      : ""}
                </Button>
              );
            }
            return <li key={index}>{children}</li>;
          })

        ) : (
          <></>
        )}
        {props.setCurrentPage(items)}
      </List>
    </nav>
  );
}
const MyGoalSuccess = (props) => {
  const { t } = useTranslation();
  const { state } = useLocation();

  // workload form select
  const [selectLibrary, setLibrary] = React.useState(1);
  const [showAlignment, setShowAlignment] = React.useState(false);

  const [formData, setFormData] = React.useState({
    type: null,
    value: null,
  })

  const [selectOption, setSelectOption] = React.useState({
    type: ['1', '2', '3'],
    value: ['1', '2', '3'],
  })
  const [comment, setComment] = React.useState("");
  const [rating, setRating] = React.useState("");


  const _ = require("lodash");

  const chooseLibrary = (val) => {
    setLibrary(val)
  }
  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "#343A40",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#343A40",
      color: "#FFFFFF",
      padding: "11px 15px",
    },
  }));
  // ----------------------------------
  const useStyles = makeStyles({
    root: {
      fontSize: "16px",
    },
    plusSvg: {
      "& > path": {
        fill: "#fff",
        stroke: "#fff",
      }
    },
    statusGraph: {
      "& > path": {
        fill: "#fff"
      }
    },
    internalIcon: {
      "& > path": {
        fill: "#fff"
      },
      '& g > path': {
        fill: '#fff'
      },
    },
    linkIcon: {
      "& > path": {
        fill: "#A0A0A0"
      },
      '& g > path': {
        fill: '#A0A0A0'
      },
    },
    paginationRoot: {
      color: `${cssVariables.color.primary}`,
      backgroundColor: "white!important",
      minWidth: "30px!important",
      padding: "5px!important",
    },
    paginationSelected: {
      color: "white!important",
      border: "1px solid rgba(93, 161, 150, 0.5)!important",
      backgroundColor: `${cssVariables.color.primary}!important`,
      minWidth: "30px!important",
      padding: "5px!important",
    },
    clickable: {
      cursor: "pointer",
      transition: "color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      '&:hover': {
        color: 'rgb(65, 112, 105) !important'
      }
    },
    fillDisable: {
      '& > path': {
        fill: '#A0A0A0'
      },
      '& g > path': {
        fill: '#A0A0A0'
      },
    },
    btn: {
      '& > svg': {
        marginLeft: "10px"
      },
    },
    boxIcon: {
      backgroundColor: "#ffffff",
      borderRadius: "50%",
      width: "40px",
      height: "40px",
      "box-shadow": "0px 4px 4px rgba(0, 0, 0, 0.15)",
      border: "none",
      transition: "0.5s",
      cursor: "pointer",
      margin: "0 20px",
      "&:hover": {
        transition: "0.5s",
        animation: `$shadow 1.2s infinite`,
        transform: "scale(1.2)",
      },
    },
  });
  const classes = useStyles();
  const styles = {
    link: {
      color: "#5DA196",
      cursor: "pointer",
    },
    end: {
      color: "#A3A3A3",
    },
  };

  const navigate = useNavigate();
  const back = (val) => {
    if (showAlignment) {
      setShowAlignment(false);
    } else
      goto(val, state)
  }
  const goto = (route, data) => {
    if (route) {
      if (route === 'mygoal' && state.isEvaluator && state.formEvaluateId) route += '/' + state.formEvaluateId

      route = '/' + route
    }

    if (data) {
      navigate("/kpi" + route, { replace: true, state: data });
    } else {
      navigate("/kpi" + route, { replace: true });
    }
  }
  const chooseAlignment = () => {
    if (showAlignment == false) {
      setShowAlignment(true);
    } else
      goto('mygoal-create/result', state)
  }
  const handleChange = (event, type) => {
    const {
      target: { value },
    } = event;
    var data = {};
    if (type == 'evaluator') {
      data = { evaluator: value === 'string' ? value.split(',') : value }
    } else if (type == 'matric') {
      data = { goalMetric: value }
    } else if (type == 'unit') {
      data = { unit: value }
    } else if (type == 'condition') {
      data = { condition: value }
    }
    setFormData(data)
  };


  const getTitle = () => {
    let title = t('mygoal.label.title')

    if (state?.isEvaluator && state?.owner?.code) {
      title = state?.owner.firstname + ' ' + state?.owner.lastname
      title += '\'s ' + t('label.goal')
    }

    return title
  }

  return (
    <>
      <Helmet>
        <title>{getTitle()} | KPI </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Grid container pt={2} pb={2}>
            <Typography fontSize={16} lineHeight={1} color="#68717A">
              <span style={styles.link} onClick={() => goto('kpi/home')}>
                {t('label.home')}
              </span> /
              <span style={styles.link} onClick={() => goto('mygoal', state)}>
                {` ${getTitle()}`}
              </span> /
              <span style={styles.end} >
                {` ${t('mygoal.page.createGoal')}`}
              </span>
            </Typography>
          </Grid>
          {/* start portfoliio 10*/}
          {/* <Grid container item> */}
          <Grid container textAlign="center" justifyContent='center' style={{ height: '90vh', alignItems: 'center', backgroundColor: '#fff' }}>
            <Box style={{ paddingLeft: '30vw', paddingRight: '30vw', paddingTop: 40, paddingBottom: 40 }}>
              <Grid item md={12}>
                <SuccessIcon />
              </Grid>
              <Grid item md={12} >
                <Typography variant="h1" fontSize={36} lineHeight="39.6px" fontWeight="500" color="#404349">
                  {t('mygoal.label.createdSuccess')}
                </Typography>
              </Grid>
              <Grid item md={12} pr={1} mt={1} mb={3}>
                <Typography fontSize={16} color="#404349">
                  {t('mygoal.label.createdSuccessDesc')}
                </Typography>
              </Grid>
              <Grid lg={12} xs={12} item textAlign="center">
                <Button
                  size="small"
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={() => { back('mygoal') }}
                  color="primary"
                  variant="contained"
                  style={{ paddingLeft: 30, paddingRight: 30, textTransform: 'none' }}
                >
                  <Typography>{t('mygoal.label.returnToMyGoal')}</Typography>
                </Button>
              </Grid>
              <Divider style={{ marginTop: 20, marginBottom: 20 }} />
              <Box sx={{ backgroundColor: "#F5F5F5", width: "100%", "box-shadow": "inset 0px 4px 5px rgba(0, 0, 0, 0.05)" }}>
                <Box sx={{ display: "flex", flexFlow: "column", justifyContent: "center", alignItems: "center", paddingTop: "25px", width: "100%" }}>
                  <Typography fontSize={18} lineHeight="26.91px" fontWeight={500} >{t('evaluation.experienceWithIPOP')} </Typography>
                  <Typography fontSize={14} lineHeight="20.93px" fontWeight={400} pt="5px" sx={{ color: "#939393" }} >{t('evaluation.feedback')}</Typography>
                  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "20px 0px" }}>

                    {FeedbackRating.map((rating, i) => (
                      <BootstrapTooltip title={rating.label} placement="top" key={i}>
                        <Box className={`${classes.boxIcon}`}>
                          <img src={rating.icon} alt={rating.label} onClick={() => setRating(rating.id)}></img>
                        </Box>
                      </BootstrapTooltip>
                    ))}
                  </Box>
                  <Box sx={{ maxWidth: "500px", width: "100%" }}>
                    <TextField
                      fullWidth
                      name="comment"
                      placeholder={t('evaluation.pleaseLeaveYourComment')}
                      onChange={(e) => setComment(e.target.value)}
                      value={comment}
                      variant="outlined"
                      multiline
                      rows={2}
                    />
                  </Box>
                  <Typography fontSize={10} lineHeight="14.95px" fontWeight={400} variant="sub_label" pt="10px" pb="15px">{t('evaluation.characterDesignBy')} <span style={{ color: "#939393", fontWeight: "500" }}>SODA</span></Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Container>
      </Box>
    </>
  );
};
export default MyGoalSuccess;
